import { render } from "./WidgetView.vue?vue&type=template&id=69afbaed&scoped=true"
import script from "./WidgetView.vue?vue&type=script&lang=js"
export * from "./WidgetView.vue?vue&type=script&lang=js"

import "./WidgetView.vue?vue&type=style&index=0&id=69afbaed&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69afbaed"]])

export default __exports__